import { render, staticRenderFns } from "./PurchaseContent.vue?vue&type=template&id=e2bb0aa0&scoped=true&"
import script from "./PurchaseContent.vue?vue&type=script&lang=js&"
export * from "./PurchaseContent.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseContent.vue?vue&type=style&index=0&id=e2bb0aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bb0aa0",
  null
  
)

export default component.exports